import React, {Component} from "react";
import ConnectAuth from "./ConnectAuth";

export default class ConnectCallback extends Component {
    componentDidMount(): void {
        ConnectAuth.triggerExternalLogin();
    }

    render(): JSX.Element {
        return <h1 className="h3" style={{color: "#fff", textAlign: "center"}}>Loading...</h1>;
    }
}